var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center align-center"},[_c('v-btn',{attrs:{"block":"","dark":"","color":"#cc3300"},on:{"click":_vm.generateError}},[_vm._v(" Click me! ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }